import { createIdentifier } from '@wix/thunderbolt-ioc'
import type { IThunderboltCssComponentRenderer } from './types'

export const name = 'renderer' as const

export const STYLE_OVERRIDES_ID = 'STYLE_OVERRIDES_ID'
export const RendererPropsProviderSym = Symbol('RendererPropsProviderSym')
export const PageTransitionsHandlerSymbol = Symbol('PageTransitionsHandlerSymbol')
export const ThunderboltRootComponentRendererSym = Symbol('ThunderboltRootComponentRendererSymbol')
export const ComponentCssSym = Symbol('ComponentsCssSymbol')
export const PageCssRendererSymbol = createIdentifier<IThunderboltCssComponentRenderer>(Symbol('PageCssRendererSymbol'))
export const ShapesCssVarRendererVSMSymbol = createIdentifier<IThunderboltCssComponentRenderer>(
	Symbol('ShapesCssVarRendererVSMSymbol')
)
export const PagePreviewRegionHostRendererSymbol = Symbol('PagePreviewRegionHostRendererSymbol')
export const AppDidMountServiceSymbol = Symbol('AppDidMountServiceSymbol')
